import { SELECT_RETURN_OR_EXCHANGE } from '../constants/ActionTypes'

export default function selectReturnOrExchange(returnOrExchange, lineNumber) {
    return {
        type: SELECT_RETURN_OR_EXCHANGE,
        returnOrExchange,
        lineNumber
    }
}
